import React, { createContext, useContext, useState } from 'react';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
    const [isAddProfileOpen, setAddProfileOpen] = useState(false);
    const [profileToEdit, setProfileToEdit] = useState(null);

    const toggleAddProfile = () => {
        setAddProfileOpen(!isAddProfileOpen);
    };

    const openEditProfile = (profile) => {
        setProfileToEdit(profile);
        setAddProfileOpen(true);
    };

    return (
        <ModalContext.Provider value={{ isAddProfileOpen, toggleAddProfile, profileToEdit, setProfileToEdit, openEditProfile }}>
            {children}
        </ModalContext.Provider>
    );
};

// Custom hook to use the modal context
export const useModal = () => {
    return useContext(ModalContext);
};
